import { useState, useEffect, RefObject } from "react";
import { PersonalData } from "../../../../../models/formsModels/PersonalData";
import {EMAIL_REGEX, PHONE_REGEX, PHONE_REGEX2} from "../../../../../utils/constants";

import { FormControlLabel, RadioGroup } from '@mui/material';
import {StyledRadio} from "../formComponents/StyledRadio";
import nextArrow from '../../../../../assets/img/arrow-right-form.svg';
import nextArrowGrey from '../../../../../assets/img/arrow-right-form-grey.svg';
import './PersonalDataBuySuscriptions.css';

interface PersonalDataProps {
  personalData: PersonalData;
  setPersonalData: (value: any) => void;
  setNext: (value: any) => void;
  miComponenteRef:RefObject<HTMLDivElement>;
}

const PersonalDataBuySubscriptions = (personalDataProps: PersonalDataProps) => {


    const [validMatchEmail, setValidMatchEmail] = useState(false);
    const [selectedSex, setSelectedSex] = useState('');
    const [validationPassOne, setValidationPassOne] = useState(false);

    const [personalDataValidation, setPersonalDataValidation] = useState<PersonalData>({
      nombre: '',
      apellidos: '',
      email: '',
      dptelefono: '',
      dpnacimiento: '',
      dpaltura: '',
      dppeso: '',
      dpsexo: '',
      dpmetapas: '',
      dpmetapadetalle: '',
      dpmembarazada: '',
      dpmtrimestre:'',
    });

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { value,name } = event.target;
        personalDataProps.setPersonalData((prevFormData: PersonalData) => ({ ...prevFormData, [name]: value }));
        setPersonalDataValidation((prevFormData: PersonalData) => ({ ...prevFormData, [name]: value }));
    };

    const CheckIsValid = () => {

      const isValid = (          
        (personalDataProps.personalData.nombre !== '') &&
        (personalDataProps.personalData.apellidos !== '') &&
        (personalDataProps.personalData.email !== '') &&
        (personalDataProps.personalData.dptelefono !== '') &&
        (personalDataProps.personalData.dpnacimiento !== '') &&
        (personalDataProps.personalData.dpaltura !== '') &&
        (personalDataProps.personalData.dppeso !== '') &&
        (personalDataProps.personalData.dpsexo !== '') &&
        //validPhone &&
        (PHONE_REGEX.test(personalDataProps.personalData.dptelefono) || PHONE_REGEX2.test(personalDataProps.personalData.dptelefono)) &&
        EMAIL_REGEX.test(personalDataProps.personalData.email) &&
        validMatchEmail

      )
      setValidationPassOne(isValid);
    }

    useEffect(() => {
      personalDataProps.miComponenteRef.current?.scrollIntoView({block: "start",behavior: 'smooth'});
    },[]);

    useEffect(() => {
      CheckIsValid();
    },[personalDataValidation,validMatchEmail]);


      return (
        <>
        <div className="name-fields">
          <div className="fam-groups">
            <label htmlFor="nombreCliente">*Nombre</label>
            <input type="text" 
            name="nombre" 
            id="nombreCliente" 
            defaultValue={personalDataProps.personalData.nombre}
            onChange={handleInputChange}
            required
            style={{marginBottom:"0px"}}
            />
          </div>
          
          <div className="fam-groups">
            <label htmlFor="apellidosCliente">*Apellidos</label>
            <input type="text" 
            name="apellidos" 
            id="apellidosCliente" 
            defaultValue={personalDataProps.personalData.apellidos}
            onChange={handleInputChange}
            required
            style={{marginBottom:"0px"}}
            />
            </div>
            
        </div>
        <div className="email-fields">
          
          <div className="fam-groups">
            <div className="email-container">
              <label htmlFor="emailCliente">*Correo electrónico</label>
              <input 
              type="email" 
              name="email" 
              id="emailCliente" 
              defaultValue={personalDataProps.personalData.email}
              required
              onChange={handleInputChange} 
              />
            </div>
            {!EMAIL_REGEX.test(personalDataProps.personalData.email) && personalDataProps.personalData.email!==''?
              <p className="instructions">El correo no es correcto.</p>:<></>
            }
          </div>

          <div className="fam-groups">
            <div className="confirm-email-container">
              <label htmlFor="confirmarEmailCliente">*Repita el correo electrónico</label>
              <input 
              type="email" 
              name="" 
              id="confirmarEmailCliente" 
              onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
                setValidMatchEmail(personalDataProps.personalData.email===event.target.value)
              }}
              required
              />
            </div>
            {(!validMatchEmail && personalDataProps.personalData.email!=='')?
              <p className="instructions">Deben coincidir los correos electrónicos.</p>:<></>
            }
          </div>
        </div>

        <div className="phone-birth-fields"> 
          <div className="fam-groups">
            <div className="confirm-phone-container">
              <label htmlFor="telefonoCliente">*Teléfono</label>
              <input type="tel" 
              name="dptelefono" 
              id="telefonoCliente" 
              placeholder="+34" 
              defaultValue={personalDataProps.personalData.dptelefono}
              onChange={handleInputChange} 
              required
              />
              {!(PHONE_REGEX.test(personalDataProps.personalData.dptelefono) || PHONE_REGEX2.test(personalDataProps.personalData.dptelefono)) && personalDataProps.personalData.dptelefono!==''?
                <p className="instructions">El teléfono no es correcto.</p>:<></>
              }
            </div>
          </div>
        
          <div className="fam-groups">
            <div className="confirm-date-container">
              <label htmlFor="fechaNacimientoCliente">*Año de nacimiento</label>
              <input type="text" 
              name="dpnacimiento" 
              id="fechaNacimientoCliente" 
              placeholder="YYYY" 
              defaultValue={personalDataProps.personalData.dpnacimiento}
              onChange={handleInputChange}
              minLength={4}
              maxLength={4}
              required
              />
              <></>
            </div>
          </div>
        </div>
          
        <div className="height-weight-fields">  
          <div className="fam-groups">
            <label htmlFor="alturaCliente">*Altura</label>
            <input type="text" 
            name="dpaltura" 
            id="alturaCliente" 
            placeholder="En CM" 
            defaultValue={personalDataProps.personalData.dpaltura}
            onChange={handleInputChange}
            required
            />
          </div>
          <div className="fam-groups">
            <label htmlFor="pesoCliente">*Peso</label>
            <input 
            type="text" 
            name="dppeso" 
            id="pesoCliente" 
            placeholder="En KG" 
            defaultValue={personalDataProps.personalData.dppeso}
            onChange={handleInputChange}
            required
            />
          </div>
        </div>  
        <label className="sexo-label" style={{fontSize:'14px', marginBottom:'0px'}}>*Sexo</label>
          <div id="sexo-fields"> 
            <RadioGroup name="dpsexo" className="materialui-fields-check">
              <FormControlLabel className="materialui-fields-label" control={
                <StyledRadio 
                  id="sexoHombre" 
                  value="h"
                  checked={personalDataProps.personalData.dpsexo==="h"}
                  onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {handleInputChange(event); setSelectedSex("h");}} 
                  required
                />} label="Hombre" />
              <FormControlLabel className="materialui-fields-label" control={
                <StyledRadio 
                  id="sexoMujer" 
                  value="m"
                  checked={personalDataProps.personalData.dpsexo==="m"}
                  onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {handleInputChange(event); setSelectedSex("m");}} 
                  required 
                />} label="Mujer" />
            </RadioGroup> 
          </div>
          { (selectedSex==="m" || personalDataProps.personalData.dpsexo==="m") && (
            <div className="sexo-mujer">
              <p>¿Estás en alguna de estas etapas?</p>
              <div>
                <RadioGroup name="dpmetapas" className="materialui-fields-check">
                  <FormControlLabel className="materialui-fields-label" control={
                    <StyledRadio 
                      id="etapasEmbarazoLactancia" 
                      value="Lactancia"
                      checked={personalDataProps.personalData.dpmetapas==="Lactancia"}
                      onChange={handleInputChange}  
                    />} label="Lactancia" />
                  <FormControlLabel className="materialui-fields-label" control={
                    <StyledRadio 
                      id="etapasEmbarazoMenopausia" 
                      value="Menopausia"
                      checked={personalDataProps.personalData.dpmetapas==="Menopausia"}
                      onChange={handleInputChange}
                    />} label="Menopausia" />
                    <FormControlLabel className="materialui-fields-label" control={
                    <StyledRadio 
                      id="etapasEmbarazoNo" 
                      value="No"
                      checked={personalDataProps.personalData.dpmetapas==="No"}
                      onChange={handleInputChange}
                    />} label="No" />
                </RadioGroup>
                <input 
                type="text" 
                name="dpmetapadetalle" 
                placeholder="¿Quieres darnos algún detalle concreto sobre ello?"
                defaultValue={personalDataProps.personalData.dpmetapadetalle}
                onChange={handleInputChange} 
                maxLength={200}
                />
              </div>
              <p>¿Estás embarazada?</p>
              <div>
                <RadioGroup name="dpmembarazada" className="materialui-fields-check">
                <FormControlLabel className="materialui-fields-label" control={
                  <StyledRadio 
                    id="embarazoSi" 
                    value="Si"
                    checked={personalDataProps.personalData.dpmembarazada==="Si"}
                    onChange={handleInputChange}
                  />} label="Si" />
                <FormControlLabel className="materialui-fields-label" control={
                  <StyledRadio 
                    id="embarazoNo" 
                    value="No"
                    checked={personalDataProps.personalData.dpmembarazada==="No"}
                    onChange={handleInputChange}
                  />} label="No" />
                </RadioGroup>
                <input 
                type="text" 
                name="dpmtrimestre" 
                placeholder="¿En qué trimestre te encuentras?"
                defaultValue={personalDataProps.personalData.dpmtrimestre}
                onChange={handleInputChange}
                />
              </div>
            </div>                
          )}
          <hr />
          <button className="next-field next-field-personal-data" disabled={!validationPassOne} onClick={()=>{
            personalDataProps.setNext(2);
            personalDataProps.miComponenteRef.current?.scrollIntoView({block: "start",behavior: 'smooth'});
          }}>Siguiente {!validationPassOne?<img src={nextArrowGrey} alt={'next'} />:<img src={nextArrow} alt={'next'} />}</button>
        </>
      );
      
}

export default PersonalDataBuySubscriptions;